import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import SAddProductMain from "../components/products/AddProductMain";

const SAddProduct = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <SAddProductMain />
      </main>
    </>
  );
};

export default SAddProduct;
